import styled from 'styled-components';

export const Section = styled.section`
  display: block;
  position: relative;
  border: 2px solid #FFF;
  background: #FFF;

  &:fullscreen {
    > img { 
      display: none;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  height: 100vh;

  @media only screen and (min-width: 2001px) {
    align-items: center;
    justify-content: center;
  }

  @media only screen and (max-width: 1190px) {
    align-items: normal;
  }
`;

export const Content = styled.div`
  display: flex;
  border: 0.188rem solid #6EE1DC;
  margin: 1.875rem;

  max-width: 2000px;
  width: 100%;

`;

export const ContentRating = styled.div`
  display: flex;
  position: relative;
  flex: 3;

  width: 100%;
  padding: 0 2.5rem 0 0;

  @media only screen and (max-width: 768px) {
   padding: 0 1.25rem;
  }
`;

export const Mel = styled.img`
  width: 100%;
  height: 100%;
  
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const Logo = styled.img`
  position: absolute;
  bottom: 0.625rem;
  right: 3.125rem;

  width: 175px;

  @media only screen and (max-width: 1280px) {
    width: 130px;
    right: 1.125rem;
  }

  @media only screen and (max-width: 768px) {
    width: 95px;
    bottom: 0;
  }
`;

export const ContentThanks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
`;

export const TextCenter = styled.p`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 4rem;
  line-height: 6rem;

  color: #0E4C54;

  text-align: center;

  @media only screen and (max-width: 1280px) {
    font-size: 2.188rem;
  }

  @media only screen and (max-width: 865px) {
    font-size: 1.563rem;
  }
`;

export const FullScreen = styled.img`
  position: absolute;
  right: 50px;
  top: 45px;
  z-index: 99;
`;